import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  open() {
    // Fetch modal from template
    const template = document.getElementById('dynamic-modal-template')
    const clone = template.content.cloneNode(true)
    document.body.appendChild(clone)
    const modal = document.getElementById('dynamic-modal')

    // Update modal content
    const titleElement = modal.querySelector('[data-modal-title]')
    const bodyElement = modal.querySelector('[data-modal-body]')

    if (titleElement) titleElement.textContent = this.element.dataset.dynamicModalTitle || ''
    if (bodyElement) bodyElement.textContent = this.element.dataset.dynamicModalBody || ''

    // Show the modal
    modal.showModal()
  }
}
